import Game from '../views/Game.vue';
import HostGame from '../views/HostGame.vue';
import JoinGame from '../views/JoinGame.vue';
import Sandbox from '../views/Sandbox.vue';
import Home from '../views/Home.vue';

const config = require('../config');

const routes = [
    { path: '/', component: Home },
    { path: '/host', component: HostGame },
    { path: '/join', component: JoinGame },
    { path: '/sandbox', component: Sandbox },
    { path: '/game/:gameId', component: Game },
];

if(config.production){
    for(let route of routes) {
        route.path = config.productionRoot + route.path;
    }
}

export default routes;